module.exports = __webpack_public_path__ + "static/media/404-verkehr.960fde32.png";